import React, { useState } from 'react';
import { MotifSelect, MotifOption, MotifLabel, MotifFormField } from '@ey-xd/motif-react';
import { pursuitLeaderConstants } from '../../../constants/pursuitLeaderConstants';

const DropDownSelect = ({ label, options, defaultValue, onDropDownValueChanged }) => {
  const [value, setValue] = useState(defaultValue || null);

  const handleSelectChange = value => {
    setValue(value);
    onDropDownValueChanged(value);
  };

  return (
    <MotifFormField className="dropDownForm">
      <MotifLabel id="select-label-visible-options">
        {label || pursuitLeaderConstants.numberFormat}
      </MotifLabel>
      <MotifSelect
        className="dropdown"
        value={value}
        onChange={handleSelectChange}
        visibleOptions={options.length}
        ariaLabelledBy="select-label-visible-options"
        styled={{ outerWidth: 50 }}
      >
        {options.map(option => (
          <MotifOption key={option.value} value={option.value}>
            {option.label}
          </MotifOption>
        ))}
      </MotifSelect>
    </MotifFormField>
  );
};

export default DropDownSelect;
